function theme(dark) {
  let t = {
    background: dark ? '#262e47' : '#FAFAFA', //#303030' : '#FAFAFA',
    plainBackground: dark ? '#121212' : '#FFFFFF',
    lighterbg: dark ? '#262e47' : '#FAFAFA', //'#404040' : '#EAEAEA',
    backgroundcolor: {
      fill: dark ? '#303030' : '#FAFAFA'
    },
    legend:  {color: dark ? '#FFFFFF' : '#060606'},
    title: {
      fontSize: 16,
      color: dark ? '#FAFAFA' : '#000000'
    },
    subtitle: {
      fontSize: 14,
      color: dark? '#2F2F2F' : '#2F2F2F'
    },
    palette: dark ?
      [
        '#dccefa', '#ffe0bd', '#009688', '#ebd197', '#afafaf',
        '#cfc2f4', '#ffcd94', '#35a79c', '#b48811', '#f8f8fa',
        '#c5b2ed', '#eac086', '#54b2a9', '#a2790d', '#e5e6eb',
        '#b69fe5', '#ffad60', '#65c3ba', '#bb9b49', '#c0c2ce',
        '#a58cd8', '#ffe39f', '#83d0c9', '#d2d4dc', '#a69eb0'
      ] :
      [
        '#0018F9', '#0E4C92', '#7285A5', '#95C8D8',
        '#4D516D', '#598BAF', '#89CFEF', '#000080',
        '#4682B4', '#57A0D2', '#5097A4', '#73C2FB',
        '#6693F5', '#008ECC', '#0F52BA', '#0080FE',
        '#1134A6', '#131E3A', '#003151', '#1C2951'
      ]
  }
  return(t)
}

const ui = {
  theme
}

export default ui